export default {
  getComments: (state) => state.comments,
  getRating: (state) => state.rating
}
